"use client";

import * as React from "react";
import { Facebook, Instagram, MapPin, Phone, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
const services = ["Lawn Maintenance", "Mulching", "Landscape Design", "Tree and Shrub Care", "Spring and Fall Cleanups", "Patios", "Retaining Walls", "Snow Removal"];
const serviceAreas = ["Pittsburgh", "Plum", "Monroeville", "Murrysville", "Penn Hills", "Oakmont"];
const contactInfo = {
  phone: "(412) 758-8781",
  address: "2746 Leechburg Rd, Pittsburgh, PA 15239"
};
export default function SiteFooter() {
  const currentYear = new Date().getFullYear();
  return <section id="site-footer" className="bg-primary text-primary-foreground pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586632/img/nieser_landscaping_logo_light.png" alt="Nieser Landscaping" className="h-7 w-auto" />
            </Link>
            <p className="text-primary-foreground/80 text-sm leading-relaxed">
              Providing reliable, professional landscaping services to homeowners with over 40 years of trusted local experience.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="text-lg font-semibold tracking-tight">Our Services</h3>
            <ul className="flex flex-col gap-2.5">
              {services.slice(0, 6).map((service, i) => <li key={service} data-index={i}>
                  <Link to={`/${service.toLowerCase().replace(/\s+/g, "-")}`} className="text-primary-foreground/80 hover:text-primary-foreground text-sm transition-colors">
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="text-lg font-semibold tracking-tight">Contact Us</h3>
            <ul className="flex flex-col gap-4">
              <li data-index={0} className="flex items-start gap-3">
                <Phone className="text-accent mt-0.5 size-5 shrink-0" />
                <div className="flex flex-col">
                  <span className="text-primary-foreground/80 text-xs uppercase tracking-wider">Call Us</span>
                  <Link to="tel:+14127588781" className="hover:text-accent text-sm font-medium transition-colors">
                    {contactInfo.phone}
                  </Link>
                </div>
              </li>
              <li data-index={1} className="flex items-start gap-3">
                <MapPin className="text-accent mt-0.5 size-5 shrink-0" />
                <div className="flex flex-col">
                  <span className="text-primary-foreground/80 text-xs uppercase tracking-wider">Location</span>
                  <span className="text-sm leading-tight">
                    {contactInfo.address}
                  </span>
                </div>
              </li>
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="text-lg font-semibold tracking-tight">Service Areas</h3>
            <ul className="grid grid-cols-2 gap-2.5 sm:grid-cols-1">
              {serviceAreas.map((area, i) => <li key={area} data-index={i} className="flex items-center gap-2">
                  <div className="bg-accent size-1.5 rounded-full" />
                  <span className="text-primary-foreground/80 text-sm">{area}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <Separator className="bg-primary-foreground/10 my-8" />

        {}
        <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
          <p className="text-primary-foreground/60 text-sm">
            &copy; {currentYear} Nieser Landscaping. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="#" className="text-primary-foreground/60 hover:text-accent transition-colors" aria-label="Facebook">
              <Facebook className="size-5" />
            </Link>
            <Link to="#" className="text-primary-foreground/60 hover:text-accent transition-colors" aria-label="Instagram">
              <Instagram className="size-5" />
            </Link>
            <Link to="#" className="text-primary-foreground/60 hover:text-accent transition-colors" aria-label="Twitter">
              <Twitter className="size-5" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}